import { Stack, Typography, Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { convertToPlaces } from "../../helpers/helpers";
import Dividers from "../../Common/Dividers";
import PropTypes from "prop-types";

const StyledItemTotal = styled(Stack)(({ theme }) => ({
  width: "100%",
  minWidth: "250px",
  backgroundColor: theme.palette.neutral.dark,
  color: theme.palette.neutral.light,
  textAlign: "left",
  padding: "10px",
  borderRadius: "5px",
}));

const StyledText = styled(Typography)({
  fontSize: "14px",
});

const StyledDivider = styled(Dividers)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.neutral.main}`,
}));

const StyledTotalText = styled(Typography)({
  fontSize: "14px",
  fontWeight: 700,
});

const ItemSummeryCustomer = ({ ...props }) => {
  const {
    item,
    qty,
    unit_price,
    total_price,
    estimated_shipping_charges,
    artwork_charges,
    extra_charges,
    sub_total,
    isLoading, // New prop for loading state
    originalQty, // New prop to show original quantity
    sales_order_item_extra_charges,
    shippingEnabled = true,
  } = props;

  return (
    <StyledItemTotal spacing={2}>
      <Typography fontSize={"24px"}>{item?.name}</Typography>
      <Stack spacing={1}>
        <Stack direction={"row"} justifyContent="space-between">
          <StyledText>Total Units</StyledText>
          {isLoading ? (
            <Skeleton width={60} />
          ) : (
            <Stack direction="row" alignItems="center" spacing={1}>
              <StyledText>{qty}</StyledText>
              {originalQty && originalQty !== qty && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    textDecoration: "line-through", 
                    color: "grey.500" 
                  }}
                >
                  ({originalQty})
                </Typography>
              )}
            </Stack>
          )}
        </Stack>
        <Stack direction={"row"} justifyContent="space-between">
          <StyledText>Unit Price</StyledText>
          {isLoading ? (
            <Skeleton width={80} />
          ) : (
            <StyledText>{convertToPlaces(unit_price)}</StyledText>
          )}
        </Stack>
        <Stack direction={"row"} justifyContent="space-between">
          <StyledText>Unit Total</StyledText>
          {isLoading ? (
            <Skeleton width={80} />
          ) : (
            <StyledText>{convertToPlaces(total_price)}</StyledText>
          )}
        </Stack>
        {shippingEnabled && (
          <Stack direction={"row"} justifyContent="space-between">
            <StyledText>Estimated Shipping</StyledText>
            {isLoading ? (
              <Skeleton width={80} />
            ) : (
              <StyledText>{convertToPlaces(estimated_shipping_charges)}</StyledText>
            )}
          </Stack>
        )}
        <Stack direction={"row"} justifyContent="space-between">
          <StyledText>Extra Charges</StyledText>          
        </Stack>
        {!isLoading ? (
            <>
              {sales_order_item_extra_charges?.map((odr, i) => (
                <Stack direction={"row"} justifyContent="space-between">
                  <StyledText>{odr?.extra_charge?.name}</StyledText>
                  <StyledText
                    style={{ 
                      textAlign: "left",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      position: "relative",
                      cursor: "pointer"
                    }}
                    title={odr.reference.length > 20 ? odr.reference : ""}
                  >
                    {odr.reference.length > 20 ? `${odr.reference.substring(0, 20)}...` : odr.reference} 
                  </StyledText>
                  <StyledText>{convertToPlaces(odr?.cost * odr?.qty)}</StyledText>
                </Stack>
              ))}
            </>
          ) : null}
        <StyledDivider />
        <Stack direction={"row"} justifyContent="space-between">
          <StyledTotalText>Sub Total</StyledTotalText>
          {isLoading ? (
            <Skeleton width={100} />
          ) : (
            <StyledTotalText>{convertToPlaces(sub_total)}</StyledTotalText>
          )}
        </Stack>
      </Stack>
    </StyledItemTotal>
  );
};

ItemSummeryCustomer.propTypes = {
  sub_total: PropTypes.number,
  extra_charges: PropTypes.number,
  artwork_charges: PropTypes.number,
  total_price: PropTypes.number,
  unit_price: PropTypes.number,
  qty: PropTypes.number,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  originalQty: PropTypes.number,
};

ItemSummeryCustomer.defaultProps = {
  sub_total: 0,
  extra_charges: 0,
  artwork_charges: 0,
  total_price: 0,
  unit_price: 0,
  qty: 0,
  item: {},
  isLoading: false,
  originalQty: null,
};

export default ItemSummeryCustomer;
